import { Yield } from '../../abacus/interfaces/yield.interface'

export const targetSectorYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
